import { DateTime } from 'luxon';

import type { DraftTimelog } from '@/types';

import type { CalendarEventWithColor } from '../../types';

export class DraftsLayoutModel {
  buildDraftPseudoEvents(drafts: DraftTimelog[], weekStart: DateTime): CalendarEventWithColor[] {
    const weekEnd = weekStart.plus({ days: 6 }).endOf('day');

    return drafts
      .filter((draft) => {
        const start = DateTime.fromISO(draft.start);

        return start.isValid && start >= weekStart && start <= weekEnd;
      })
      .map((draft) => {
        const start = DateTime.fromISO(draft.start);
        const end = start.plus({ minutes: draft.durationMinutes });

        return {
          id: `draft-${draft.id}`,
          calendarId: '__drafts__',
          externalId: '',
          recurrenceId: null,
          summary: draft.taskKey ?? draft.taskTitle ?? 'Черновик',
          description: draft.comment || null,
          startsAt: start.toISO()!,
          endsAt: end.toISO()!,
          isAllDay: false,
          location: null,
          worklogId: null,
          myResponseStatus: null,
          attendees: [],
          color: '#f59e0b',
          isDraft: true,
          draftData: draft,
        };
      });
  }
}
